"use client";

import RootErrorSurface from "@/components/root-error-surface";

export default function GlobalError(props: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return <RootErrorSurface {...props} />;
}
